/**
 * Activity Tags for Onboarding
 * 25 multilingual tags for user preference selection
 */

export const ACTIVITY_TAGS = [
  {
    id: 'eating',
    label: {
      TH: 'กินอาหาร',
      EN: 'Eating',
      CN: '用餐'
    }
  },
  {
    id: 'japanese_food',
    label: {
      TH: 'อาหารญี่ปุ่น',
      EN: 'Japanese Food',
      CN: '日本料理'
    }
  },
  {
    id: 'thai_food',
    label: {
      TH: 'อาหารไทย',
      EN: 'Thai Food',
      CN: '泰国菜'
    }
  },
  {
    id: 'concert',
    label: {
      TH: 'คอนเสิร์ต',
      EN: 'Concert',
      CN: '音乐会'
    }
  },
  {
    id: 'live_music',
    label: {
      TH: 'ดนตรีสด',
      EN: 'Live Music',
      CN: '现场音乐'
    }
  },
  {
    id: 'nightlife',
    label: {
      TH: 'ไนท์ไลฟ์',
      EN: 'Nightlife',
      CN: '夜生活'
    }
  },
  {
    id: 'spa',
    label: {
      TH: 'สปา',
      EN: 'Spa',
      CN: '温泉'
    }
  },
  {
    id: 'massage',
    label: {
      TH: 'นวดแผนไทย',
      EN: 'Massage',
      CN: '按摩'
    }
  },
  {
    id: 'health',
    label: {
      TH: 'สุขภาพ',
      EN: 'Health',
      CN: '健康'
    }
  },
  {
    id: 'fitness',
    label: {
      TH: 'ฟิตเนส',
      EN: 'Fitness',
      CN: '健身'
    }
  },
  {
    id: 'temple',
    label: {
      TH: 'วัด',
      EN: 'Temple',
      CN: '寺庙'
    }
  },
  {
    id: 'culture',
    label: {
      TH: 'วัฒนธรรม',
      EN: 'Culture',
      CN: '文化'
    }
  },
  {
    id: 'museum',
    label: {
      TH: 'พิพิธภัณฑ์',
      EN: 'Museum',
      CN: '博物馆'
    }
  },
  {
    id: 'art',
    label: {
      TH: 'ศิลปะ',
      EN: 'Art',
      CN: '艺术'
    }
  },
  {
    id: 'shopping',
    label: {
      TH: 'ช้อปปิ้ง',
      EN: 'Shopping',
      CN: '购物'
    }
  },
  {
    id: 'market',
    label: {
      TH: 'ตลาด',
      EN: 'Market',
      CN: '市场'
    }
  },
  {
    id: 'nature',
    label: {
      TH: 'ธรรมชาติ',
      EN: 'Nature',
      CN: '自然'
    }
  },
  {
    id: 'beach',
    label: {
      TH: 'ชายหาด',
      EN: 'Beach',
      CN: '海滩'
    }
  },
  {
    id: 'hiking',
    label: {
      TH: 'เดินป่า',
      EN: 'Hiking',
      CN: '徒步'
    }
  },
  {
    id: 'sports',
    label: {
      TH: 'กีฬา',
      EN: 'Sports',
      CN: '运动'
    }
  },
  {
    id: 'photography',
    label: {
      TH: 'ถ่ายภาพ',
      EN: 'Photography',
      CN: '摄影'
    }
  },
  {
    id: 'coffee',
    label: {
      TH: 'ร้านกาแฟ',
      EN: 'Coffee Shop',
      CN: '咖啡店'
    }
  },
  {
    id: 'tea',
    label: {
      TH: 'ร้านชา',
      EN: 'Tea House',
      CN: '茶馆'
    }
  },
  {
    id: 'bar',
    label: {
      TH: 'บาร์',
      EN: 'Bar',
      CN: '酒吧'
    }
  },
  {
    id: 'dessert',
    label: {
      TH: 'ของหวาน',
      EN: 'Dessert',
      CN: '甜点'
    }
  }
];

/**
 * Get tag label by language
 * @param {string} tagId - Tag identifier
 * @param {string} language - Language code (TH, EN, CN)
 * @returns {string} Localized label
 */
export function getTagLabel(tagId, language = 'EN') {
  const tag = ACTIVITY_TAGS.find(t => t.id === tagId);
  return tag?.label[language] || tagId;
}

/**
 * Validate tag selection
 * @param {string[]} selectedTags - Array of tag IDs
 * @returns {{valid: boolean, error: string|null}}
 */
export function validateTagSelection(selectedTags) {
  if (!selectedTags || !Array.isArray(selectedTags)) {
    return { valid: false, error: 'Tags must be an array' };
  }

  if (selectedTags.length < 2) {
    return { valid: false, error: 'Please select at least 2 tags' };
  }

  if (selectedTags.length > 10) {
    return { valid: false, error: 'Please select no more than 10 tags' };
  }

  // Validate all tags exist
  const validTagIds = ACTIVITY_TAGS.map(t => t.id);
  const invalidTags = selectedTags.filter(id => !validTagIds.includes(id));

  if (invalidTags.length > 0) {
    return { valid: false, error: `Invalid tags: ${invalidTags.join(', ')}` };
  }

  return { valid: true, error: null };
}
